// extracted by mini-css-extract-plugin
module.exports = {"link":"giftCardImageGrid_link__0yMUk","image":"giftCardImageGrid_image__X5mYh","nbi":"giftCardImageGrid_nbi__xM7YH"};